import cn from 'clsx';

import skeletonStyles from '@/styles/Skeleton.module.css';
import styles from './LoadingSkeleton.module.css';

export const LoadingSkeleton = () => {
  return (
    <div className={styles.container} data-testid="media-loading-skeleton">
      <div className={styles.tabsContainer}>
        <div className={cn(styles.tabSkeleton, skeletonStyles.skeleton)} />
        <div className={cn(styles.tabSkeleton, skeletonStyles.skeleton)} />
        <div className={cn(styles.tabSkeleton, skeletonStyles.skeleton)} />
      </div>
      <div className={styles.imageContainer}>
        <div className={cn(styles.imageSkeleton, skeletonStyles.skeleton)} />
        <div className={cn(styles.imageSkeleton, skeletonStyles.skeleton)} />
        <div className={cn(styles.imageSkeleton, skeletonStyles.skeleton)} />
        <div className={cn(styles.imageSkeleton, skeletonStyles.skeleton)} />
      </div>
      <div className={styles.footerContainer}>
        <div className={cn(styles.pageLabelSkeleton, skeletonStyles.skeleton)} data-visible={false} />
        <div className={cn(styles.labelSkeleton, skeletonStyles.skeleton)} />
        <div className={cn(styles.pageLabelSkeleton, skeletonStyles.skeleton)} data-visible={true} />
      </div>
    </div>
  );
};
